import { CurrencyValue } from '../../model'

export function getSwapFeeDisplay(swapFee?: CurrencyValue) {
  return swapFee ? swapFee.formatWithSymbol() : '-'
}

export function getPriceImpactDisplay(slippagePercent?: string) {
  return slippagePercent ? `${slippagePercent === '0' ? '' : '-'}${slippagePercent}%` : '-'
}

export function getSlippageToleranceDisplay(slippageTolerance: number) {
  return `${(slippageTolerance / 10).toFixed(1)}%`
}
